import { Optional } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Observable, firstValueFrom, iif, of, switchMap } from 'rxjs';

import { PreviousPageLocationCacheService } from '../client-caching/previous-page-cache.service';
import { MasterDetailDependencyService } from './master-detail-dependency.service';

export class ChildDependencyResolver<TMaster, TDetail> {
    constructor(
        private dependencyService: MasterDetailDependencyService<TMaster, TDetail>,
        @Optional() private previousPageLocationCacheService: PreviousPageLocationCacheService,
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<TDetail | undefined> {
        return this.previousPageLocationCacheService
            ? this.previousPageLocationCacheService.getPreviousPage<TDetail | undefined>().pipe(
                  switchMap((data) => {
                      return iif(() => !data, this.dependencyService.getChildContext(route), of(data));
                  }),
              )
            : this.dependencyService.getChildContext(route);
    }

    preResolve(route: ActivatedRouteSnapshot) {
        firstValueFrom(this.dependencyService.getPreResolvedDetailData(route));
    }
}
